import type { ProviderId } from './providers'

/**
 * provider 브랜드 마크.
 *
 * 두 자리가 같은 그림을 쓴다. provider 버튼은 브랜드 면 위에 서고 로그인 방법 목록은 우리 면
 * 위에 선다. 그림을 두 벌 두면 브랜드가 자산을 바꿀 때 한쪽만 고쳐진다.
 *
 * 장식이라 대체 텍스트를 비운다. 접근성 이름은 이것을 감싸는 버튼이나 항목이 갖는다.
 */

export function GoogleMark({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      />
      <path
        fill="#FBBC05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      />
    </svg>
  )
}

/**
 * 네이버 마크. 초록 면 위의 흰색이라 글자 토큰과 값이 같고 색 토큰을 따로 두지 않는다.
 * currentColor로 그려 감싸는 자리의 글자색을 그대로 물려받는다.
 */
export function NaverMark({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      <path
        fill="currentColor"
        d="M11.65 10.7 8.2 5.6H5.4v8.8h2.95V9.3l3.45 5.1h2.8V5.6h-2.95v5.1z"
      />
    </svg>
  )
}

/**
 * 우리 면 위에 서는 마크. 목록 항목이 쓴다.
 *
 * 네이버는 자기 면을 함께 세운다. 마크가 흰색 한 벌뿐이라 우리 면에 그대로 얹으면 보이지
 * 않는다. 구글 마크는 자기 색을 갖고 있어 면이 필요 없다.
 */
export function ProviderMark({ provider }: { provider: ProviderId }) {
  if (provider === 'naver') {
    return (
      <span className="bg-provider-naver-surface text-provider-naver-ink flex size-5 shrink-0 items-center justify-center rounded-[5px]">
        <NaverMark size={12} />
      </span>
    )
  }
  return <GoogleMark />
}
